module.exports = [{"type":"title","text":"2025-05-14"},{"type":"normal","text":"","style":{"font-weight":"bold"},"children":[{"type":"html","text":"Public: New investigation questionnaire added."}]}]


//////////////////
// WEBPACK FOOTER
// ./src/config/en-US/changelog/2025-05-14.json
// module id = MrPT
// module chunks = 3